import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import gameStateReducer from "../features/game-state/game-state.slice";
import gameOverviewReducer from "../features/game-state/games-overview.slice";
import storageReducer from "../features/game-state/storage.slice";
import userProfileReducer from "../features/game-state/user-profile.slice";

export const store = configureStore({
  reducer: {
    gameState: gameStateReducer,
    gameOverviewState: gameOverviewReducer,
    storageState: storageReducer,
    userProfileState: userProfileReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
